<template>
  <ResponsiveLayout>
    <form class="kds-main-wrapper">
      <h1>Init mocked webmd one handshake</h1>
      <div class="kds-content-block">
        <TextField
          ref="firstNameRef"
          autocomplete="given-name"
          label="First Name"
          v-bind="fieldAttrs.firstName"
        />
        <TextField
          autocomplete="family-name"
          label="Last Name"
          v-bind="fieldAttrs.lastName"
        />
        <TextField
          autocomplete="email"
          label="Email"
          type="email"
          v-bind="fieldAttrs.email"
        />
        <DateOfBirthField v-bind="fieldAttrs.dob" />
        <TextField
          hint="This is the users identifier within the group"
          label="Unique ID"
          v-bind="fieldAttrs.uniqueID"
        />
        <TextField
          hint="This is the sponsor the user belongs to - this usually maps to our concept of corporates"
          label="Top Level Sponsor ID"
          v-bind="fieldAttrs.tlid"
        />
        <TextField
          hint="This is the sub sponsor the user belongs to - this usually maps to our concept of corporates"
          label="Reside Sponsor ID (optional)"
          v-bind="fieldAttrs.resideId"
        />
      </div>
      <BaseButton
        text="Go to Kaia"
        v-bind="submitAttrs"
      />
    </form>
  </ResponsiveLayout>
</template>

<script setup>
import BaseButton from '@shared/components/BaseButton.vue'
import DateOfBirthField from '@shared/components/form/DateOfBirthField.vue'
import TextField from '@shared/components/form/TextField.vue'
import useForm from '@shared/composables/useForm'
import { ref } from 'vue'
import ResponsiveLayout from '@shared/components/ResponsiveLayout.vue'

const form = ref({
  firstName: '',
  lastName: '',
  email: '',
  dob: '',
  uniqueID: '',
  tlid: '',
  resideId: '',
})

const config = ref({
  firstName: { validations: ['required'] },
  lastName: { validations: ['required'] },
  email: { validations: ['required', 'email'] },
  dob: { validations: ['dob'] },
  uniqueID: { validations: ['required'] },
  tlid: { validations: ['required'] },
  resideId: {},
})

const handleSubmitSuccess = () => {
  console.info(form)
  const [year, month, day] = form.value.dob.split('-')
  const url = new URL(
    'https://api-msk.stage.kaiahealth.com/saml-sp/webmd-one/mocked',
  )
  Object.entries({
    FirstName: form.value.firstName,
    LastName: form.value.lastName,
    Email: form.value.email,
    DOB: year && month && day ? `${month}${day}${year}` : null,
    UniqueId: form.value.uniqueID,
    TLID_SPID: form.value.tlid,
    Reside_SPID: form.value.resideId,
  })
    .filter(([, value]) => !!value)
    .forEach(([key, value]) => url.searchParams.append(key, value))
  url.searchParams.append('redirect_host', window.location.hostname)
  url.searchParams.append('redirect_port', window.location.port)
  if (!window.location.protocol.startsWith('https')) {
    url.searchParams.append('redirect_scheme', 'http')
  }
  console.info(`redirecting to ${url.toString()}`)
  window.location = url.toString()
}

const { fieldAttrs, submitAttrs } = useForm(form, config, {
  onSubmit: () => {},
  onSuccess: handleSubmitSuccess,
  onError: (error) => console.error(error),
})
</script>

<style lang="scss"></style>
